import React, { useState, useEffect } from "react";
import FavoriteBorderIcon from "@material-ui/icons/FavoriteBorder";
import FavoriteIcon from "@material-ui/icons/Favorite";
import { makeStyles } from "@material-ui/core/styles";
import FavoriteForm from "./FavoriteForm.jsx";
import { FaRegHeart } from "react-icons/fa";
import useLocalStorage from "../../Utils/LocalStorageUtil.js";
import useAppStore from "../../Store/SearchStore.jsx"; // Import useAppStore from the store
import { fetchAndSendSavedProductsToApi } from "../../Utils/ProductUtil.jsx";
import "../Styles/LikeDislike.scss";
import { favoriteProductAPI } from "../../Services/userService.js";

function LikeDislikeButtons(props) {
  const [isClicked, setIsClicked] = useState(false);
  const [selection, setSelection] = useState(null);
  const [data, setData] = useState(null);
  const email = window.localStorage.getItem("email");
  const prompt = window.localStorage.getItem("prompt");
  const giftID = props.gift_id;
  const dataSent = {
    email: window.localStorage.getItem("email"),
    giftId: props.gift_id,
    text: window.localStorage.getItem("prompt"),
  };
  const [error, setError] = useState(null);
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [savedProducts, setSavedProducts] = useLocalStorage(
    "savedProducts",
    []
  );
  const [triggered, setTriggered] = useState(false);
  const loggedIn = localStorage.getItem("loggedin");

  // Handles open POPUP events
  const handlePopupOpen = () => {
    setIsPopupVisible(true);
  };

  // Handles open POPUP events
  const handlePopupClose = () => {
    setIsPopupVisible(false);
  };

  async function handleFavorite(e) {
    e.preventDefault();
    // console.log(dataSent)
    if (isClicked !== true) {
      if (window.localStorage.getItem("token") !== null) {
        const res = await favoriteProductAPI(email, giftID, prompt);
        if (res.status === 401 || res.status === 403) {
          setError(res.message);
          return false;
        } else {
          setIsClicked(true);
          return true;
        }
      } else return false;
    }
  }

  // Handles Favorite Clicked
  const handleFavoriteButtonClick = async (e) => {
    // handleLike(e);

    if ((await handleFavorite(e)) == false) {
      // handlePopupOpen();
      let savedEvents = JSON.parse(localStorage.getItem("saved_event") || "[]");
      savedEvents.push(props.gift_id);
      localStorage.setItem("saved_event", JSON.stringify(savedEvents));

      // const eventData = JSON.parse(localStorage.getItem("eventData") || "[]");
      // const eventDataCount = eventData.length;
    }
  };

  return (
    <div className="">
      {/* <div>{isPopupVisible && <PopUp onClose={handlePopupClose} />}</div> */}
      <button onClick={(e) => handleFavoriteButtonClick(e)}>
        <FavoriteForm giftID={props.gift_id} gift_image={props.gift_image} />
      </button>
    </div>
  );
}
export default LikeDislikeButtons;
